import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from "rxjs/Observable";
import {environment} from "../../environments/environment";
import {TimeSheet, UserCheckInCheckOut} from '../models/timeSheet';
;


@Injectable({
  providedIn: 'root'
})
export class TimeSheetService {

constructor(private http: HttpClient ) { }


  public getTimeSheets(userID: number,fromDate: string, toDate: string, page: number, pageSize: number): Observable<TimeSheet[]> {
    return this.http.get<TimeSheet[]>(environment.APIENDPOINT + '/timeTracker/searchSummaryList?userId='+userID+'&fromDate='+fromDate+'&toDate='+toDate+'&page='+page+'&size='+pageSize, {
      headers: this.setHeaders(),
      responseType: 'json'
    });
  }

  public getTimeSheetsOfUser(userID: number,dateCheck: string): Observable<UserCheckInCheckOut[]> {
    return this.http.get<UserCheckInCheckOut[]>(environment.APIENDPOINT + '/timeTracker/users/'+ userID +'/listForPeriod?fromDate='+dateCheck+'&toDate='+dateCheck, {
      headers: this.setHeaders(),
      responseType: 'json'
    });
  }

  public getMechanicList(): Observable<any[]> {
    return this.http.get<any[]>(environment.APIENDPOINT + '/timeTracker/mechanics', {
      headers: this.setHeaders(),
      responseType: 'json'
    });
  }



  private setHeaders() {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let userTenant = localStorage.getItem('userTenant');
    let authHeader = new HttpHeaders({'Authorization': 'Bearer ' + currentUser.token , 'X-Tenant' : userTenant });
    return authHeader;
  }



}


